export const product_status = [
  {
    id: 1,
    name: 'Activo'
  },
  {
    id: 2,
    name: 'Inactivo'
  }
]


// WEBPACK FOOTER //
// ./src/components/products/mocks.js